// extracted by mini-css-extract-plugin
export default {"inspectionContractStatus":"status_inspectionContractStatus__Wcn7k"};